<template>
  <div class="pending-event-store">
    <!-- 待举办活动门店 -->
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.anEventStoreToBeHeld')"></NavHeaderBar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" :finished-text="$t('tips.noMoreData')" @load="onLoad" :immediate-check="false">
        <div class="activity-item" v-for="(item, index) in list" :key="index">
          <!-- 门店分配时间： -->
          <div class="header-info">{{ $t('shared.storeAllocationTime') }}：{{ item.localCreateTime }}</div>
          <div class="item-body">
            <div class="store-name">{{ item.customerName }}</div>
            <div class="ba-name">{{ $t('form.assignedBaBd') }}：{{ item.backlogUserName }}</div>
            <!-- 邀约日期： -->
            <div class="invite-date">{{ $t('shared.dateOfInvitation') }}：{{ item.backlogTime }}</div>
            <!-- 期望时间： -->
            <div class="expect-date">{{ $t('shared.expectTime') }}：{{ item.expectedTime }}</div>
          </div>
          <div class="oper-btn">
            <van-button plain type="primary" color="#555555" size="small" @click="toPage(`/storeExpansion/visitSellInDetail?visitId=${item.sourceId}`)">{{ $t('button.invitationInfo') }}.</van-button>
            <van-button type="info" color="#307bff" size="small" @click="toPage(`/createEvent?customerId=${item.customerId}&customerName=${item.customerName}&pageType=pendingEventStore&eventType=1`)">{{ $t('button.launch') }}</van-button>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { backlogEventApi } from '@/api/pendingEventStore'
export default {
  data () {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      page: 1,
      pageSize: 10
    }
  },
  activated () {
    this.page = 1
    // Initial load
    this.onLoad()
  },
  methods: {
    onRefresh () {
      this.finished = false
      this.loading = true
      this.page = 1
      this.onLoad()
    },
    onLoad () {
      // Mock API call
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      const data = {
        page: this.page,
        limit: 10
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      backlogEventApi(data).then(res => {
        Toast.clear()
        if (this.page === 1) {
          this.list = res.data.list
        } else {
          this.list = [...this.list, ...res.data.list]
        }
        this.loading = false
        this.page++
        if (this.list.length >= Number(res.data.totalRow)) {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    toPage (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.pending-event-store {
  font-size: 13px;

  .right-header {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .icon-img {
      width: 20px;
      height: 20px;
    }
  }
  .activity-item {
    background-color: #fff;
    margin-bottom: 1px; // Divider effect
    border-bottom: 1px solid #f0f0f0;

    .header-info {
      display: flex;
      justify-content: space-between;
      padding: 12px 10px 10px 10px;
      border-bottom: 1px solid #f0f0f0;
      color: #7f7f7f;
    }

    .item-body {
      padding: 10px;
      color: #555;
      .store-name {
        color: #333;
        font-weight: bold;
        margin-bottom: 8px;
      }
      .ba-name,
      .invite-date {
        margin-bottom: 5px;
      }
    }
    .oper-btn {
      display: flex;
      justify-content: flex-end;
      padding: 10px;
      padding-top: 0;
      /deep/.van-button {
        height: 30px;
        border-radius: 5px;
        margin-left: 10px;
      }
    }
  }
}
</style>
